import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=b46bb988"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocuments.vue?vue&type=style&index=0&id=b46bb988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports